<template>
  <div class="container">
    <div v-if="loading">
      <SkeletonSearchbar />
      <SkeletonHeader /> 
      <SkeletonTixstockFeaturedCategories />
      <SkeletonTixstockTrendingCategories />
      <SkeletonEventCard />
    </div>
    <div v-else>
      <TixstockSearchbar />
      <div v-if="!isMobile || !isTab">
        <TixstockHeader />
      </div>
      <div v-if="isMobile || isTab">
        <TixstockMobileHeader />
      </div>
      <div class="mt-20">
        <TixstockFeaturedCategories />
      </div>
      <div class="mt-30">
        <TixstockTrendingCategories />
      </div>
      <div class="mt-30">
        <TixstockPopularCategories />
      </div>
    </div>
  </div>
</template>

<script>
import TixstockHeader from "@/components/InternationalEvents/TixstockHeader.vue";
import TixstockMobileHeader from "@/components/InternationalEvents/TixstockMobileHeader.vue";

import TixstockSearchbar from "@/components/InternationalEvents/TixstockSearchbar.vue";
import TixstockFeaturedCategories from "@/components/InternationalEvents/TixstockFeaturedCategories.vue";
import TixstockTrendingCategories from "@/components/InternationalEvents/TixstockTrendingCategories.vue";
import TixstockPopularCategories from "@/components/InternationalEvents/TixstockPopularCategories.vue";
import SkeletonSearchbar from "./Skeleton/SkeletonSearchbar.vue";
import SkeletonHeader from "./Skeleton/SkeletonHeader.vue";
import SkeletonTixstockFeaturedCategories from "./Skeleton/SkeletonTixstockFeaturedCategories.vue";
import SkeletonTixstockTrendingCategories from "./Skeleton/SkeletonTixstockTrendingCategories.vue";
import SkeletonEventCard from "./Skeleton/SkeletonEventCard.vue";
import { mapGetters } from "vuex";

import {
    FETCH_INTERNATIONAL_EVENTS_CATEGORIES
} from "@/store/actions.type";

export default {
  name: "InternationalEventsIndex",
  components: {
    TixstockHeader,
    TixstockFeaturedCategories,
    TixstockSearchbar,
    TixstockTrendingCategories,
    TixstockPopularCategories,
    TixstockMobileHeader,
    SkeletonSearchbar,
    SkeletonHeader,
    SkeletonTixstockFeaturedCategories,
    SkeletonTixstockTrendingCategories,
    SkeletonEventCard
  },
  data(){
      return {
        isMobile: window.innerWidth < 992,
        isTab: window.innerWidth <= 1200,
        loading: true,
      }
    },
    computed: {
      ...mapGetters(['featuredCategories'])
    },
    mounted() {
      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 992;
        this.isTab = window.innerWidth <= 1200;
      });
      this.fetchCategories();
    },
    methods: {
      fetchCategories() {
      let params ={
        skip:0,
        limit:999
      }
      this.$store.dispatch(FETCH_INTERNATIONAL_EVENTS_CATEGORIES).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    }
    }
};
</script>
